import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import {Divider, Form, Row} from "antd";
import {RTLButton, RTLCol} from "../RTLKit";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import TextField from "../formFields/TextField";
import SelectField from "../formFields/SelectField";

class WizardFormSecondPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props._reduxForm.getAreaList()
    }

    __getAreaStateList() {
        let areaList = this.props._reduxForm.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );
            }
        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __getAddressList(list) {//this.props._reduxForm.userList.lists[0]
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].text, value: list[i].text, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        let _self=this
        const {handleSubmit, previousPage} = this.props;
        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();

        var cityList = [];

        /* ----- find selected city  -----*/
        if(this.props.initialValues && this.state.mode == 'edit') {
            this.state.stateId = this.props.initialValues.state._id
        }

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Divider orientation="left">آدرس</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle">
                        <Row gutter={16}>

                            <Field
                                name="stateId"
                                component={SelectFieldForLoadState}
                                label="استان"
                                list={stateList}
                                onChangeVal={(stateId) => { _self.setState({stateId : stateId})}  }
                                defaultValue={this.props._reduxForm.userList.lists[0] && this.props._reduxForm.userList.lists[0].state ? this.props._reduxForm.userList.lists[0].state : ''}
                            />
                            <Field
                                name="cityId"
                                component={SelectFieldForLoadCity}
                                label="شهر"
                                list={cityList}
                            />
                            {this.props._reduxForm.userList.lists[0] && this.props._reduxForm.userList.lists[0].addresses.length > 0 ?
                                <Field
                                    name="address"
                                    component={SelectField}
                                    label="آدرس"
                                    placeholder="آدرس"
                                    list={this.__getAddressList(this.props._reduxForm.userList.lists[0].addresses)}
                                />
                                :
                                <Field
                                    name="address"
                                    component={TextField}
                                    type="text"
                                    label="آدرس"
                                    placeholder="آدرس"
                                />
                            }
                        </Row>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLButton type="primary"  shape="round" htmlType="submit" className="login-form-button">
                        مرحله بعد
                    </RTLButton>
                    <RTLButton className="backBtn" type="default" shape="round" onClick={previousPage}>
                        مرحله قبل
                    </RTLButton>
                </Row>
            </form>
        );
    }
};

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(WizardFormSecondPage);
